<div [hidden]="!isBlocked" class="content">
	<div class="overlay">
		<div class="la-ball-scale-multiple la-2x">
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
</div>